import React from 'react'
import {Box, SvgIconProps, Typography} from '@mui/material'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

// The uppercase caption that heads each block of the answer form ("Questa assunzione", "Parte del
// corpo", "Prossima assunzione"), with a small brand-colored icon to tell the blocks apart at a
// glance on a long mobile page.

interface SectionTitleNewProps {
  icon: React.ComponentType<SvgIconProps>
  children: React.ReactNode
}

export default function SectionTitleNew({icon: Icon, children}: SectionTitleNewProps): JSX.Element {
  return (
    <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 1.5}}>
      <Icon sx={{fontSize: 18, color: 'primary.main'}} />
      <Typography
        variant="caption"
        sx={{fontWeight: 600, color: NEUTRAL_SCALE[700], textTransform: 'uppercase', letterSpacing: '0.05em'}}
      >
        {children}
      </Typography>
    </Box>
  )
}
